import { Clock, Users, User, Package, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const TIERS = [
  {
    icon: User,
    name: "One-on-one lessons",
    desc: "Individual attention, paced entirely around your child.",
    tag: "Online or in person",
  },
  {
    icon: Users,
    name: "Small group lessons",
    desc: "Learn with a handful of peers — personal attention, shared energy.",
    tag: "Online or in person",
  },
  {
    icon: Package,
    name: "Term & exam packages",
    desc: "Structured term support and matric exam preparation bundles.",
    tag: "Curriculum in finalisation",
  },
];

export const Pricing = () => {
  return (
    <section id="pricing" className="bg-muted/60" data-testid="pricing-section">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
        <div className="mx-auto max-w-2xl text-center">
          <p className="eyebrow-label" data-testid="pricing-eyebrow">Pricing &amp; packages</p>
          <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-testid="pricing-heading">
            Simple options. <span className="text-secondary">Honest pricing.</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground sm:text-lg">
            Our pricing and packages are being finalised together with the curriculum and will be published soon.
            Enquire now and we'll confirm the latest options with you directly.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-testid="pricing-grid">
          {TIERS.map(({ icon: Icon, name, desc, tag }, i) => (
            <div
              key={name}
              className="relative flex flex-col rounded-2xl border border-border bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
              data-testid={`pricing-card-${i}`}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-secondary/10 text-secondary">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="mt-5 font-heading text-xl font-bold text-slate-900">{name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground">{desc}</p>
              <div className="mt-6 rounded-xl border border-dashed border-amber-500/60 bg-amber-50 px-4 py-3">
                <p className="flex items-center gap-2 text-xs font-bold text-amber-700">
                  <Clock className="h-3.5 w-3.5" /> Price to be confirmed
                </p>
                <p className="mt-1 text-xs text-amber-700/80">Published once the curriculum is finalised.</p>
              </div>
              <p className="mt-4 text-xs font-semibold uppercase tracking-wider text-muted-foreground">{tag}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Button
            asChild
            size="lg"
            className="rounded-full bg-primary px-8 font-heading font-bold hover:bg-[#082A45]"
            data-testid="pricing-enquire-btn"
          >
            <a href="#consultation">
              Ask about pricing <ArrowRight className="ml-1 h-4 w-4" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};
